import { lightTheme } from '../../styles';
import { TextButtonStyled } from './textButton.styled';

export const TextButton = ({
  color = lightTheme.darkGray,
  children,
  ...props
}) => {
  return (
    <TextButtonStyled type="button" color={color} {...props}>
      {children}
    </TextButtonStyled>
  );
};
